/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Store/PackardShipping',[
    'jquery',
    'lodash',
    'global/Logger',
    'global/Forms',
    'global/Validation',
    'plugins/accounting.min'
], function ($, _, Logger, Forms, Validation, accounting) {
    'use strict';

    var prepaidShippingServiceName = 'Prepaid';
    var pickupShippingServiceName = 'Pick up';
    var packardShippingServices = ['Collect', '3rd Party', 'COD', 'Bill Back'];


    var freightCollectForm = {
        Fields: [
            {
                "Name": 'Carrier',
                "Field": '#carrier-{id}',
                "Param": 'carrier',
                "Type": 'Text',
                'Validators': [
                        {
                            "Type": 'MaxLength',
                            "Value": 50,
                            "ErrorMsg": 'The carrier entered exceeds the maximum allowed length (50 characters)'
                        }
                ]
            },
            {
                "Name": 'Account Number',
                "Field": '#account-number-{id}',
                "Param": 'accountNumber',
                "Type": 'Text',
                'Validators': [
                        {
                            "Type": 'MaxLength',
                            "Value": 100,
                            "ErrorMsg": 'The account number entered exceeds the maximum allowed length (100 characters)'
                        }
                ]
            }
        ],
        Validate: true
    };

    var storePickupForm = {
        Fields: [
            {
                "Name": "Pickup Person's Name",
                "Field": '#pickup-person-name-{id}',
                "Param": 'pickupPersonName',
                'Type': 'Text',
                'Validators': [
                        {
                            "Type": 'MaxLength',
                            "Value": 100,
                            "ErrorMsg": 'The pickup person\'s name entered exceeds the maximum allowed length (100 characters)'
                        }
                ]
            },
            {
                "Name": "Pickup Person's Phone #",
                "Field": '#pickup-person-phone-{id}',
                "Param": 'pickupPersonPhone',
                "Type": 'Text',
                'Validators': [
                    {
                        'Type': 'Phone'
                    }
                ]
            },
            {
                "Name": 'Warehouse Location',
                "Field": '#pickup-location-{id}',
                'Param': 'pickupWarehouseLocationCode',
                "Type": 'Radiolist'
            }
        ],
        Validate: true
    };

    function isPackardShippingOption(serviceName) {
        return packardShippingServices.indexOf(serviceName) > -1;
    }

    function isPrepaidShippingService(serviceName) {
        return serviceName === prepaidShippingServiceName;
    }

    /**
     * Determines whether the given service name belongs to freight collect services.
     * @param {} serviceName 
     * @returns {} 
     */
    function isFreightCollectShippingService(serviceName) {
        return serviceName === packardShippingServices[0] || serviceName === packardShippingServices[1];
    }

    function isPickupShippingService(serviceName) {
        return serviceName === pickupShippingServiceName;
    }

    function formatShippingPrice(shippingService) {
        // this function is called in many areas of the site
        // sometimes there is no access to shipping method object from a partial view
        // and we get shipping service name instead, sometimes there is an object of ShippingMethodOption type
        var isShippingServiceString = typeof shippingService === 'string';
        var shippingServiceName = isShippingServiceString
            ? shippingService
            : shippingService.shippingDescription;

        if (isPrepaidShippingService(shippingServiceName) || isPickupShippingService(shippingServiceName)) {
            return 'FREE';
        }

        return 'Pending';
    }

    /**
     * Determines whether the given recipient requires freight collect data to be collected.
     * @param {} recipient 
     * @returns {} 
     */
    function doesRequireFreightCollectData(recipient) {
        if (!recipient ||
            !recipient.shippingServiceId ||
            !recipient.shippingOptions ||
            recipient.shippingOptions.length === 0) {
            return false;
        }

        var selectedShippingService = _.find(recipient.shippingOptions,
            { 'shippingServiceId': recipient.shippingServiceId });

        if (selectedShippingService === undefined || selectedShippingService === null) {
            return false;
        }

        return isFreightCollectShippingService(selectedShippingService.shippingDescription);
    }

    /**
     * Determines whether the given recipient requires pickup data to be collected.
     * @param {} recipient 
     * @returns {} 
     */
    function doesRequirePickupForm(recipient) {
        if (!recipient ||
            !recipient.shippingServiceId ||
            !recipient.shippingOptions ||
            recipient.shippingOptions.length === 0) {
            return false;
        }

        var selectedShippingService = _.find(recipient.shippingOptions,
            { 'shippingServiceId': recipient.shippingServiceId });

        if (selectedShippingService === undefined || selectedShippingService === null) {
            return false;
        }

        return isPickupShippingService(selectedShippingService.shippingDescription);
    }

    function collectShippingFormSubmitted() {
        var deferred = $.Deferred();
        $(document)
            .off('click', '[data-roc-action="submit-collect-form"]')
            .on('click', '[data-roc-action="submit-collect-form"]', function () {
                var valid = Validation.validateForm(freightCollectForm, true, false);
                if (!valid) {
                    return false;
                }

                var collectFormValues = Forms.getFormValues(freightCollectForm);
                deferred.resolve(collectFormValues);
                return true;
            });

        return deferred.promise();
    }

    function getWarehouses(selectedShipTo) {
        return $.proxyRequest({
            type: 'POST',
            dataType: 'json',
            data: JSON.stringify({
                selectedShipTo: selectedShipTo,
                orderId: '{orderId}'
            }),
            contentType: 'application/json; charset=utf-8',
            url: '/api/packard/shipping/warehouses/'
        });
    }

    function isOrderPickupRecipient(orderRecipient) {
        return orderRecipient.customFields !== null &&
            _.some(orderRecipient.customFields,
                function (value, key) {
                    return key === 'pickupLocationCode' && value !== undefined && value !== null;
                });
    }

    function hasOrderPickupRecipient(order) {
        return _.some(order.recipients, function (recipient) {
            return isOrderPickupRecipient(recipient);
        });
    }

    var PackardShipping = {
        isPackardShippingOption: isPackardShippingOption,
        formatShippingPrice: formatShippingPrice,
        isFreightCollectShippingService: isFreightCollectShippingService,
        collectShippingFormSubmitted: collectShippingFormSubmitted,
        doesRequireFreightCollectData: doesRequireFreightCollectData,
        doesRequirePickupForm: doesRequirePickupForm,
        isPickupShippingService: isPickupShippingService,
        freightCollectForm: freightCollectForm,
        getWarehouses: getWarehouses,
        storePickupForm: storePickupForm,
        hasOrderPickupRecipient: hasOrderPickupRecipient,
        isOrderPickupRecipient: isOrderPickupRecipient
    };

    Logger.debug('PackardShipping.js Loaded:', PackardShipping);

    return PackardShipping;
});
